import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
const Footer: React.FC = () => {
  // Refs for in-view detection
  const quickApproachRef = useRef(null);
  const imageRef = useRef(null);
  const bottomRef = useRef(null);

  // In-view hooks (animations trigger once when in view)
  const quickApproachInView = useInView(quickApproachRef, { once: true });
  const imageInView = useInView(imageRef, { once: true });
  const bottomInView = useInView(bottomRef, { once: true });

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const imageVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const fadeInVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.5 } },
  };

  return (
    <footer id="quick-links" className="bg-white w-full flex flex-col items-center justify-center">
      {/* Quick Approach Section */}
      <div className="contain w-full bg-[#F9F9F9] flex flex-col items-center sm:items-start justify-center gap-4 px-[50px] py-[35px]">
        <div className="border-l-2 border-[#172B6B] px-2 text-[#172B6B] font-bold text-[23px] font-subway">QUICK APPROACH</div>
        <div className="font-bold text-[#F8D835] font-subway text-[27px] sm:text-[42px]">A QUICK LINKS</div>
        <motion.div
          ref={quickApproachRef}
          initial="hidden"
          animate={quickApproachInView ? "visible" : "hidden"}
          variants={containerVariants}
          className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4"
        >
          <motion.a
            variants={itemVariants}
            href="/aboutUs"
            className="w-full flex flex-row justify-between items-center font-montserrat text-black text-[14px] px-2 py-1 border-b-2 border-black md:text-[19px] md:px-10 md:py-5 focus:outline-none shadow-md hover:bg-[#8a936d80] active:bg-[#babd8a] truncate"
          >
            About Us
            <FaArrowRight className="" />
          </motion.a>

          <motion.a
            variants={itemVariants}
            href="/tokenization"
            className="w-full flex flex-row justify-between items-center font-montserrat text-black text-[14px] px-2 py-1 border-b-2 border-black md:text-[19px] md:px-10 md:py-5 focus:outline-none shadow-md hover:bg-[#8a936d80] active:bg-[#babd8a] truncate"
          >
            Tokenization
            <FaArrowRight className="" />
          </motion.a>

          <motion.a
            variants={itemVariants}
            href="/exploration"
            className="w-full flex flex-row justify-between items-center font-montserrat text-black text-[14px] px-2 py-1 border-b-2 border-black md:text-[19px] md:px-10 md:py-5 focus:outline-none shadow-md hover:bg-[#8a936d80] active:bg-[#babd8a] truncate"
          >
            Mineral resources
            <FaArrowRight className="" />
          </motion.a>

          <motion.a
            variants={itemVariants}
            href="/roadmap"
            className="w-full flex flex-row justify-between items-center font-montserrat text-black text-[14px] px-2 py-1 border-b-2 border-black md:text-[19px] md:px-10 md:py-5 focus:outline-none shadow-md hover:bg-[#8a936d80] active:bg-[#babd8a] truncate"
          >
            Road map
            <FaArrowRight className="" />
          </motion.a>

          <motion.a
            variants={itemVariants}
            href="/investor_Portal"
            className="w-full flex flex-row justify-between items-center font-montserrat text-black text-[14px] px-2 py-1 border-b-2 border-black md:text-[19px] md:px-10 md:py-5 focus:outline-none shadow-md hover:bg-[#8a936d80] active:bg-[#babd8a] truncate"
          >
            Investor portal
            <FaArrowRight className="" />
          </motion.a>

          <motion.a
            variants={itemVariants}
            href="contact_Us"
            className="w-full flex flex-row justify-between items-center font-montserrat text-black text-[14px] px-2 py-1 border-b-2 border-black md:text-[19px] md:px-10 md:py-5 focus:outline-none shadow-md hover:bg-[#8a936d80] active:bg-[#babd8a] truncate"
          >
            Contact Us
            <FaArrowRight className="" />
          </motion.a>
        </motion.div>
      </div>

      {/* Footer Image */}
      <motion.a
        href=""
        ref={imageRef}
        initial="hidden"
        animate={imageInView ? "visible" : "hidden"}
        variants={imageVariants}
        className="w-full hover:cursor-pointer"
      >
        <img src="/footer.png" alt="footer_bg" className="w-full h-auto" />
      </motion.a>

      <div className="w-full flex flex-col justify-center items-center  p-2 sm:p-4">
        <motion.div
          ref={bottomRef}
          initial="hidden"
          animate={bottomInView ? "visible" : "hidden"}
          variants={fadeInVariants}
          className="w-full flex flex-col md:flex-row justify-center items-center gap-4 py-4 lg:justify-between "
        >
          <div className="w-full text-center text-lg text-black font-montserrat truncate">
            © 2025 Mineralex right reserved
          </div>
          <div className="w-full flex flex-col sm:flex-row justify-center items-center gap-2">
            <div className="w-full xl:float-right flex flex-col justify-center items-center gap-2  text-center">
              <motion.a
                variants={itemVariants}
                href={process.env.REACT_APP_Linktree_link}
                className="font-montserrat text-black text-base sm:text-lg hover:text-[#F8D835]"
              >
                LinkTree
              </motion.a>
              <motion.a
                variants={itemVariants}
                href={process.env.REACT_APP_Twitter_link}
                className="font-montserrat text-black text-base sm:text-lg hover:text-[#F8D835]"
              >
                Twitter
              </motion.a>
              <motion.a
                variants={itemVariants}
                href={process.env.REACT_APP_Telegram_link}
                className="font-montserrat text-black text-base sm:text-lg hover:text-[#F8D835] z-30"
              >
                Telegram
              </motion.a>
              <motion.a
                variants={itemVariants}
                href={process.env.REACT_APP_Facebook_link}
                className="font-montserrat text-black text-base sm:text-lg hover:text-[#F8D835]"
              >
                Facebook
              </motion.a>

              <motion.a
                variants={itemVariants}
                href={process.env.REACT_APP_Linkedin_link}
                className="font-montserrat text-black text-base sm:text-lg hover:text-[#F8D835]"
              >
                Linkedin
              </motion.a>

            </div>
            <div className="w-full flex flex-col justify-end items-center gap-4">
              <a href="/termsandconditions"
                className="font-montserrat text-black text-base sm:text-lg hover:text-[#F8D835]">
                Terms & Condition
              </a>
              <a
                href="/privacyPolicy"
                className="font-montserrat text-black text-base sm:text-lg hover:text-[#F8D835]">
                Privacy Policy
              </a>
              <a
                href="/cookiePolicy"
                className="font-montserrat text-black text-base sm:text-lg hover:text-[#F8D835]">
                Cookie Policy
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;